import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Devices from "../components/Devices";
import selectDevicesContainer from "../selectors/devices";
import * as actions from "../actions/devices";
import {
  fetchBatteryDevices,
  fetchMoreBatteryDevices,
  fetchUnassignedDevices,
  fetchMoreUnassignedDevices,
  assignDevicesToMember,
  resetUnassignedDevices,
} from "../actions/batteries";

const MemberDevicesContainer = (props) => {
  return <Devices {...props} />;
};

const mapStateToProps = (state) => {
  const member = state.selectedMember;
  const memberName = `${member.get("first_name") || ""} ${member.get("last_name") || ""}`.trim();
  return {
    ...selectDevicesContainer()(state),
    memberName,
  };
};

const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(actions, dispatch),
  doUnlinkMemberDevices: (memberID, vendor) => {
    dispatch(actions.unlinkMemberDevices({memberID, vendor}))
  },
  doFetchBatteryDevices: (memberId) => {
    dispatch(fetchBatteryDevices(memberId));
  },
  doFetchMoreBatteryDevices: (memberId) => {
    dispatch(fetchMoreBatteryDevices(memberId));
  },
  doFetchUnassignedDevices: () => {
    dispatch(fetchUnassignedDevices());
  },
  doFetchMoreUnassignedDevices: () => {
    dispatch(fetchMoreUnassignedDevices());
  },
  doAssignDevices: (memberId, deviceIds) => dispatch(assignDevicesToMember(memberId, deviceIds)),
  doResetUnassignedDevices: () => {
    dispatch(resetUnassignedDevices());
  },
  dispatch,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MemberDevicesContainer);
